import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@mui/material';
import { useEffect, useState } from 'react';

import Input from '../../../../../components/input/input';

import './styles.scss';

interface SaveBacktestConfigModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
}

export const SaveBacktestConfigModal = ({
  open,
  onClose,
  onSave,
}: SaveBacktestConfigModalProps) => {
  const [name, setName] = useState('');

  useEffect(() => {
    if (open) setName('');
  }, [open]);

  const handleSave = () => {
    onClose();
    onSave(name.trim());
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="save-config-modal-container">
        <div className="save-config-modal-content">
          <div className="header">
            <h1>New backtest config</h1>
            <Button className="close-button" onClick={onClose}>
              <FontAwesomeIcon icon={faX} />
            </Button>
          </div>
          <div className="items">
            <div className="item">
              <Input
                placeholder="Create a name for this backtest config (optional)"
                value={name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
              />
            </div>
          </div>
          <div className="buttons">
            <Button className="add-button" onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
